import axios from '../../../../utils/request';

function GET_LIST(params) {
    return axios.get("/statistics/OperationStatistics/index",{
        params: {
            ...params
        }
    } )
}
function EXPORT(params) {
    return  axios.get("/statistics/OperationStatistics/export",{
        params: {
            ...params
        }
    }  )
}
function openTimes(params) {
    return  axios.get("/statistics/OperationStatistics/clickList",{
        params: {
            ...params
        }
    }  )
}

function openSub(params) {
    return  axios.get("/statistics/OperationStatistics/subList",{
        params: {
            ...params
        }
    }  )
}

export default {
    GET_LIST,
    EXPORT,openTimes,openSub
};
